function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.012,
  y1: 0.464,
  x2: 1,
  y2: 0.471,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0d518e"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5ab6e5"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "img-mail-box-illustration",
  transform: "translate(-1166 -4898)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Elipse_498",
  "data-name": "Elipse 498",
  cx: 227,
  cy: 224.5,
  rx: 227,
  ry: 224.5,
  transform: "translate(1166 4898)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("g", {
  id: "undraw_mailbox_re_dvds",
  transform: "translate(1255.221 4961.332)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4167",
  "data-name": "Caminho 4167",
  d: "M422.409,643.614c6.045-5.108,9.716-13.177,8.753-21.031s-6.927-15.076-14.663-16.744-16.554,2.949-18.9,10.506c-1.293-14.569-2.783-29.749-10.529-42.156-7.014-11.234-19.162-19.273-32.328-20.711s-27.028,3.993-35.239,14.385-10.221,25.5-4.471,37.429c4.236,8.789,12.041,15.33,20.219,20.651A130.493,130.493,0,0,0,424.5,645.467",
  transform: "translate(-311.75 -324.644)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4168",
  "data-name": "Caminho 4168",
  d: "M342.393,560.015a215.315,215.315,0,0,1,63.267,85.548c.6,1.479-1.8,2.122-2.395.66a213.1,213.1,0,0,0-62.628-84.452c-1.24-1.009.526-2.757,1.756-1.756Z",
  transform: "translate(-321.623 -326.887)",
  fill: "#5ab6e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4169",
  "data-name": "Caminho 4169",
  d: "M482.836,643.614c-6.045-5.108-9.716-13.177-8.753-21.031s6.927-15.076,14.663-16.744,16.555,2.949,18.9,10.506c1.293-14.569,2.783-29.749,10.529-42.156,7.014-11.234,19.162-19.273,32.328-20.711s27.027,3.993,35.239,14.385,10.221,25.5,4.471,37.429c-4.236,8.789-12.041,15.33-20.219,20.651a130.493,130.493,0,0,1-89.248,19.524",
  transform: "translate(-368.001 -324.644)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4170",
  "data-name": "Caminho 4170",
  d: "M591.54,560.015a215.324,215.324,0,0,0-63.267,85.548c-.6,1.479,1.8,2.123,2.394.66A212.924,212.924,0,0,1,593.3,561.771c1.24-1.009-.527-2.757-1.756-1.756Z",
  transform: "translate(-386.816 -326.887)",
  fill: "#5ab6e5"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Elipse_495",
  "data-name": "Elipse 495",
  cx: 20.248,
  cy: 20.248,
  rx: 20.248,
  ry: 20.248,
  transform: "translate(112.524 104.505)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4171",
  "data-name": "Caminho 4171",
  d: "M390.513,287.388h139.5v7.632H408.321a54.485,54.485,0,0,0-54.486,54.486v86.712H338.571a2.544,2.544,0,0,1-2.544-2.544v-91.8a54.485,54.485,0,0,1,54.486-54.485Z",
  transform: "translate(-320.17 -232.432)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4172",
  "data-name": "Caminho 4172",
  d: "M460.527,630.685V514.75h33.964V630.685a2.942,2.942,0,0,1-2.939,2.939H463.466a2.942,2.942,0,0,1-2.939-2.939Z",
  transform: "translate(-363.352 -311.291)",
  fill: "#5ab6e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4173",
  "data-name": "Caminho 4173",
  d: "M325.027,431.13V336.857a56.67,56.67,0,0,1,56.606-56.607H525.547V434.4H328.293A3.27,3.27,0,0,1,325.027,431.13ZM524.241,281.556H381.633a55.363,55.363,0,0,0-55.3,55.3V431.13a1.962,1.962,0,0,0,1.959,1.959H524.24Z",
  transform: "translate(-316.355 -229.957)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4174",
  "data-name": "Caminho 4174",
  d: "M481.73,338.454A11.77,11.77,0,0,1,469.973,326.7V242.44a1.962,1.962,0,0,0-1.96-1.959H422.293a3.27,3.27,0,0,1-3.266-3.266v-30.7a3.27,3.27,0,0,1,3.266-3.266h67.929a3.27,3.27,0,0,1,3.266,3.266V326.7A11.77,11.77,0,0,1,481.73,338.454Z",
  transform: "translate(-348.958 -203.25)",
  fill: "#5ab6e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4175",
  "data-name": "Caminho 4175",
  d: "M620.257,278.25h0a37.152,37.152,0,0,1,37.23,37.074v107.32h73.154a11.081,11.081,0,0,1,11.1,11.057H583.027V315.324a37.152,37.152,0,0,1,37.23-37.074Z",
  transform: "translate(-405.84 -229.263)",
  fill: "#0d518e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4176",
  "data-name": "Caminho 4176",
  d: "M626.313,327.355l7.709,31.845,150.8-36.506-7.709-31.845a2.376,2.376,0,0,0-1.54-1.695,2.348,2.348,0,0,0-.871-.131l-87.17-45.135a2.4,2.4,0,0,0-3.041.731L642.481,303.2,626.643,325.3a.336.336,0,0,0-.058.273A2.379,2.379,0,0,0,626.313,327.355Z",
  transform: "translate(-420.83 -217.254)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4177",
  "data-name": "Caminho 4177",
  d: "M626.762,325.568a.319.319,0,0,0,.133.206.365.365,0,0,0,.283.056.35.35,0,0,0,.2-.135l.054-.075.825-1.153,14.976-20.878,42-58.571a1.711,1.711,0,0,1,2.17-.52l86.495,44.785.776.4a.876.876,0,0,0,.1.034,1.041,1.041,0,0,1,.177-.017.336.336,0,0,0,.189-.16.343.343,0,0,0-.143-.463l-.107-.057-87.17-45.134a2.4,2.4,0,0,0-3.041.731L642.658,303.2,626.82,325.3A.335.335,0,0,0,626.762,325.568Z",
  transform: "translate(-421.006 -217.254)",
  fill: "#5ab6e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4178",
  "data-name": "Caminho 4178",
  d: "M694.733,322.1l3.357.372L723,325.228l16.516,1.828.976.108,20.609-16.1.79-.617,4.867-3.8,17.318-13.524.1-.95,6.16-55.593a2.909,2.909,0,0,0-2.566-3.208l-82.2-9.106a2.91,2.91,0,0,0-3.208,2.566l-4.344,39.214L695.61,287.79l-2.155,19.451-1,9.033-.292,2.616A2.911,2.911,0,0,0,694.733,322.1Z",
  transform: "translate(-443.687 -210.534)",
  fill: "#0d518e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4179",
  "data-name": "Caminho 4179",
  d: "M728.673,294.923l35.608,3.944,12.628,1.4a4.271,4.271,0,0,0,.94-8.491l-15.706-1.74-32.527-3.607a4.274,4.274,0,1,0-.943,8.5Z",
  transform: "translate(-455.037 -232.09)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4180",
  "data-name": "Caminho 4180",
  d: "M725.716,319.063c.092.016.184.033.277.042l41.335,4.579,6.9.766a4.273,4.273,0,1,0,.94-8.494l-9.979-1.1-32.743-3.628-5.51-.611a4.271,4.271,0,0,0-1.221,8.45Z",
  transform: "translate(-454.108 -240.479)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4181",
  "data-name": "Caminho 4181",
  d: "M720.1,341.508a4.271,4.271,0,0,0,3.188,2.041l16.942,1.876,30.174,3.343.007,0,.965.107,4.868-3.8a4.234,4.234,0,0,0,0-.869,4.281,4.281,0,0,0-3.78-3.8l-4.191-.466-16.627-1.84-11.964-1.327-15.454-1.713a4.272,4.272,0,0,0-4.127,6.453Z",
  transform: "translate(-453.169 -248.956)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4182",
  "data-name": "Caminho 4182",
  d: "M754.841,265.447l8.86.981,3.913.435,5.911.654a4.273,4.273,0,0,0,.94-8.494l-18.68-2.068a4.272,4.272,0,0,0-.944,8.492Z",
  transform: "translate(-464.114 -221.868)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4183",
  "data-name": "Caminho 4183",
  d: "M645.9,293.943l10.8,44.62,18.028,3.428,16.677,3.175,17.892,3.4,5.717,1.088a2.4,2.4,0,0,0,1.92-.465l4.586-3.582,2.9-2.268,20.609-16.1-13.1-54.13a2.875,2.875,0,0,0-.813-1.41,2.905,2.905,0,0,0-2.694-.73L648.04,290.437a2.907,2.907,0,0,0-2.14,3.507Z",
  transform: "translate(-427.619 -226.713)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4184",
  "data-name": "Caminho 4184",
  d: "M683.8,351.662a4.276,4.276,0,0,0,5.157,3.147l47.168-11.418a4.278,4.278,0,0,0,3.147-5.157,1.352,1.352,0,0,0-.046-.161,4.271,4.271,0,0,0-5.111-2.986l-47.167,11.418A4.276,4.276,0,0,0,683.8,351.662Z",
  transform: "translate(-440.751 -248.935)",
  fill: "#5ab6e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4185",
  "data-name": "Caminho 4185",
  d: "M690.082,372.415l16.677,3.175,35.326-8.552a4.272,4.272,0,0,0-2.01-8.3l-47.167,11.418a4.242,4.242,0,0,0-2.448,1.64A4.3,4.3,0,0,0,690.082,372.415Z",
  transform: "translate(-442.971 -257.136)",
  fill: "#5ab6e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4186",
  "data-name": "Caminho 4186",
  d: "M743.008,388.246l5.717,1.088a2.4,2.4,0,0,0,1.92-.465l4.586-3.582Z",
  transform: "translate(-461.328 -266.388)",
  fill: "#5ab6e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4187",
  "data-name": "Caminho 4187",
  d: "M698.351,318.747a4.276,4.276,0,0,0,5.157,3.147l18.269-4.423a4.278,4.278,0,0,0,3.147-5.157,4.224,4.224,0,0,0-.787-1.624,4.276,4.276,0,0,0-4.37-1.523L701.5,313.589A4.273,4.273,0,0,0,698.351,318.747Z",
  transform: "translate(-445.797 -239.945)",
  fill: "#5ab6e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4188",
  "data-name": "Caminho 4188",
  d: "M684.616,359.813l17.9,3.405,5.716,1.088a2.409,2.409,0,0,0,1.919-.464l4.59-3.583-1.61.39-3.4,2.652a1.721,1.721,0,0,1-1.371.332l-4.232-.8-17.9-3.405Zm53.453-18.641.174.72.794-.617Zm-53.453,18.641,17.9,3.405,5.716,1.088a2.409,2.409,0,0,0,1.919-.464l4.59-3.583-1.61.39-3.4,2.652a1.721,1.721,0,0,1-1.371.332l-4.232-.8-17.9-3.405Zm0,0,17.9,3.405,5.716,1.088a2.409,2.409,0,0,0,1.919-.464l4.59-3.583-1.61.39-3.4,2.652a1.721,1.721,0,0,1-1.371.332l-4.232-.8-17.9-3.405Zm-58.3-8.352,20.193,83.415a2.4,2.4,0,0,0,2.888,1.762l146.152-35.38a2.4,2.4,0,0,0,1.763-2.888l-20.193-83.415a2.377,2.377,0,0,0-1.54-1.695,2.349,2.349,0,0,0-.871-.131,2.258,2.258,0,0,0-.989.26,2.078,2.078,0,0,0-.4.246L761.324,323,743.9,336.609l-5.836,4.558v0h0l-21.4,16.706-3.538,2.769-3.4,2.653a1.722,1.722,0,0,1-1.371.332l-4.232-.8-17.9-3.405-17.911-3.406-39.229-7.466a2.346,2.346,0,0,0-1.011.022,2.4,2.4,0,0,0-1.168.677,2.691,2.691,0,0,0-.322.425,2.379,2.379,0,0,0-.273,1.787Zm58.3,8.352,17.9,3.405,5.716,1.088a2.409,2.409,0,0,0,1.919-.464l4.59-3.583-1.61.39-3.4,2.652a1.721,1.721,0,0,1-1.371.332l-4.232-.8-17.9-3.405Zm0,0,17.9,3.405,5.716,1.088a2.409,2.409,0,0,0,1.919-.464l4.59-3.583-1.61.39-3.4,2.652a1.721,1.721,0,0,1-1.371.332l-4.232-.8-17.9-3.405Zm0,0,17.9,3.405,5.716,1.088a2.409,2.409,0,0,0,1.919-.464l4.59-3.583-1.61.39-3.4,2.652a1.721,1.721,0,0,1-1.371.332l-4.232-.8-17.9-3.405Z",
  transform: "translate(-420.83 -241.36)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4189",
  "data-name": "Caminho 4189",
  d: "M684.616,359.813l17.9,3.405,5.716,1.088a2.409,2.409,0,0,0,1.919-.465l4.59-3.583-1.61.39-3.4,2.652a1.721,1.721,0,0,1-1.371.332l-4.232-.8-17.9-3.405Zm53.453-18.641.174.72.794-.617Zm-53.453,18.641,17.9,3.405,5.716,1.088a2.409,2.409,0,0,0,1.919-.465l4.59-3.583-1.61.39-3.4,2.652a1.721,1.721,0,0,1-1.371.332l-4.232-.8-17.9-3.405Zm0,0,17.9,3.405,5.716,1.088a2.409,2.409,0,0,0,1.919-.465l4.59-3.583-1.61.39-3.4,2.652a1.721,1.721,0,0,1-1.371.332l-4.232-.8-17.9-3.405Zm-57.365-10.087.089.067c.015-.024.041-.046.06-.072a1.726,1.726,0,0,1,1.558-.5l38.984,7.416,16.674,3.177,17.9,3.405,5.715,1.088a2.409,2.409,0,0,0,1.919-.465l4.59-3.583-1.611.39-3.4,2.652a1.722,1.722,0,0,1-1.371.332l-4.232-.8-17.9-3.405-17.911-3.406-39.229-7.466a2.344,2.344,0,0,0-1.011.022Zm-.938,1.735,20.193,83.415a2.4,2.4,0,0,0,2.888,1.762l146.152-35.38a2.4,2.4,0,0,0,1.762-2.888l-20.193-83.415a2.377,2.377,0,0,0-1.54-1.7,2.346,2.346,0,0,0-.871-.131,2.259,2.259,0,0,0-.989.26,2.072,2.072,0,0,0-.4.246L761.324,323,743.9,336.609l-5.836,4.558v0h-.005l-21.4,16.706-3.538,2.769-3.4,2.652a1.722,1.722,0,0,1-1.371.332l-4.232-.8-17.9-3.405-17.911-3.406-39.229-7.466a2.344,2.344,0,0,0-1.011.022,2.4,2.4,0,0,0-1.168.677,2.691,2.691,0,0,0-.322.425,2.379,2.379,0,0,0-.273,1.787Zm.666-.161a1.7,1.7,0,0,1,.3-1.431.22.22,0,0,1,.059-.077c.015-.024.041-.046.06-.072a1.726,1.726,0,0,1,1.558-.5l38.984,7.416,16.674,3.177,17.9,3.405,5.715,1.088a2.409,2.409,0,0,0,1.919-.465l4.59-3.583,2.9-2.268,20.605-16.1.794-.617,4.864-3.8,17.321-13.526,12.522-9.779a1.7,1.7,0,0,1,.645-.312,1.3,1.3,0,0,1,.2-.033,1.045,1.045,0,0,1,.177-.017,1.751,1.751,0,0,1,.588.1,1.715,1.715,0,0,1,1.1,1.21l20.193,83.415a1.711,1.711,0,0,1-1.261,2.067l-146.152,35.38a1.71,1.71,0,0,1-2.062-1.263Zm57.637,8.513,17.9,3.405,5.715,1.088a2.409,2.409,0,0,0,1.919-.465l4.59-3.583-1.611.39-3.4,2.653a1.721,1.721,0,0,1-1.371.332l-4.232-.8-17.9-3.405Zm0,0,17.9,3.405,5.715,1.088a2.409,2.409,0,0,0,1.919-.465l4.59-3.583-1.611.39-3.4,2.653a1.721,1.721,0,0,1-1.371.332l-4.232-.8-17.9-3.405Zm0,0,17.9,3.405,5.715,1.088a2.409,2.409,0,0,0,1.919-.465l4.59-3.583-1.611.39-3.4,2.653a1.721,1.721,0,0,1-1.371.332l-4.232-.8-17.9-3.405Z",
  transform: "translate(-420.83 -241.36)",
  fill: "#0d518e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4190",
  "data-name": "Caminho 4190",
  d: "M827.05,417.117a5.309,5.309,0,0,1,3.906-6.4l18.446-4.465a5.3,5.3,0,0,1,2.5,10.308l-18.446,4.465A5.309,5.309,0,0,1,827.05,417.117Z",
  transform: "translate(-490.426 -273.607)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Elipse_496",
  "data-name": "Elipse 496",
  cx: 4.572,
  cy: 4.572,
  rx: 4.572,
  ry: 4.572,
  transform: "translate(128.2 118.875)",
  fill: "#0d518e"
})));

function SvgUndrawMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 465.767,
    height: 449,
    viewBox: "0 0 465.767 449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawMail);
export default __webpack_public_path__ + "static/media/undraw_mail.b9bf96ad.svg";
export { ForwardRef as ReactComponent };